<template>
  <div class="resource h-full w-full">
    <div v-if="initialLoading">
      <div class="masonry">
        <div v-for="n in 20" :key="n" class="masonry-item">
          <div class="masonry-content">
            <el-skeleton :loading="true" animated>
              <template #template>
                <el-skeleton-item variant="image" style="width: 100%; height: 100%;" />
              </template>
            </el-skeleton>
          </div>
        </div>
      </div>
    </div>
    <el-scrollbar ref="scrollbarRef" v-else-if="resourceList.length > 0" height="100%" @end-reached="onScroll"
      :distance="100">
      <div class="masonry">
        <div v-for="item in resourceList" :key="item.id" class="masonry-item cursor-pointer "
          @click="selectonClick(item)" :class="{ 'selectborder': isResourcesSelected(item.id) }">
          <div class="masonry-content">
            <el-image :src="getPreviewSrc(item)" class="media" fit="cover" :lazy="true"
              :scroll-container="scrollWrapEl">
              <template #placeholder>
                <div class="image-slot flex items-center justify-center w-full h-full"><el-icon>
                    <Loading />
                  </el-icon></div>
              </template>
            </el-image>
            <div class="select" @click.stop="onSelect(item)" :class="{ 'multipleChoiceShow': multipleChoiceShow }">
              <span class="select-indicator" v-if="!isResourcesSelected(item.id)"></span>
              <span class="select-indicator " v-else style="border: 1px solid #2a66ff; background-color: #2a66ff;">
                <el-icon color="white">
                  <Check />
                </el-icon>
              </span>
            </div>

            <div class="hover-actions" v-if="!multipleChoiceShow">
              <el-dropdown trigger="click" @command="(cmd) => onItemCommand(cmd, item)">
                <span class="action-btn" @click.stop>
                  <el-icon>
                    <MoreFilled />
                  </el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu style="width: 120px;">
                    <el-dropdown-item command="detail">详情 </el-dropdown-item>
                    <el-dropdown-item command="download" v-if="item.file_type == '2'">下载</el-dropdown-item>
                    <el-dropdown-item command="edit" v-if="item.file_type == '1'">编辑</el-dropdown-item>
                    <el-dropdown-item command="move">移动</el-dropdown-item>
                    <el-dropdown-item command="copy">复制</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <el-button class="download-btn" type="primary" @click.stop="onDownload(item)"
              v-if="item.file_type == '2' && !multipleChoiceShow">下载</el-button>
            <el-button class="download-btn" type="primary" @click.stop="edittemplate(item)"
              v-if="item.file_type == '1' && !multipleChoiceShow">编辑</el-button>
            <div class="caption" v-if="!multipleChoiceShow"><span class="caption-text">{{ item.name || item.file_name ||
              ''
                }}</span></div>
          </div>
        </div>
      </div>
      <div v-if="loadingMore" class="masonry">
        <div v-for="n in 10" :key="'s-' + n" class="masonry-item">
          <div class="masonry-content">
            <el-skeleton :loading="true" animated>
              <template #template>
                <el-skeleton-item variant="image" style="width: 100%; height: 100%;" />
              </template>
            </el-skeleton>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <div v-else class="w-full h-full flex items-center justify-center">
      <el-empty description="暂无数据">
        <el-button v-if="showUploadWhenEmpty" type="primary" @click="emit('upload')">本地上传</el-button>
      </el-empty>
    </div>

    <el-dialog v-model="detailVisible" title="" align-center fullscreen :show-close="false" style="padding: 0;">
      <div class="detail flex items-center w-[100vw] h-[100vh]">
        <div class="left h-full w-[calc(100%-400px)] border-r border-[#eee]">
          <div class="top h-[80px] border-b border-[#eee] bg-white px-[20px] flex items-center justify-between">
            <div class="l cursor-pointer" @click="detailVisible = false">
              <el-icon>
                <CloseBold />
              </el-icon>
            </div>
            <div class="r flex items-center gap-[10px]">
              <el-tooltip class="box-item" effect="dark" content="删除" placement="top-end">
                <div class="w-[40px] flex align-center justify-center cursor-pointer"
                  @click="deleteResource(detailItem)">
                  <el-icon size="20">
                    <DeleteFilled />
                  </el-icon>
                </div>
              </el-tooltip>
              <el-tooltip class="box-item" effect="dark" content="复制" placement="top-end">
                <div class="w-[40px] flex align-center justify-center cursor-pointer" @click="copyResource(detailItem)">
                  <el-icon size="20">
                    <DocumentCopy />
                  </el-icon>
                </div>
              </el-tooltip>
              <el-tooltip class="box-item" effect="dark" content="移动" placement="top-end">
                <div class="w-[40px] flex align-center justify-center cursor-pointer" @click="moveResource(detailItem)">
                  <el-icon size="20">
                    <Right />
                  </el-icon>
                </div>
              </el-tooltip>
              <el-tooltip class="box-item" effect="dark" content="下载" placement="top-end">
                <div class="w-[40px] flex align-center justify-center cursor-pointer" @click="onDownload(detailItem)"
                  v-if="detailItem.file_type == '2'">
                  <el-icon size="20">
                    <Download />
                  </el-icon>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="bottom h-[calc(100%-80px)] bg-[#f5f7fa]">
            <div class="preview-center">
              <img v-if="detailItem?.full_preview_url" :src="getDetailPreviewSrc(detailItem)" class="big-preview" />
            </div>
          </div>
        </div>
        <div class="right w-[400px]  h-full">
          <div class="top h-[80px] border-b border-[#eee] flex items-center px-[20px] bg-white">
            <span class="title text-[16px] font-bold">详情</span>
          </div>
          <div class="bottom h-[calc(100%-80px)] bg-white overflow-auto">
            <div class="p-[20px]">
              <div class="sec">
                <div class="sec-title">文件名称</div>
                <div class="name-box">{{ detailStatic.resource.name }}</div>
              </div>
              <div class="sec">
                <div class="sec-title">基本信息</div>
                <div class="info-card">
                  <div class="info-row"><span class="info-label">资源尺寸</span><span class="info-value">{{
                    detailStatic.resource.width }} * {{ detailStatic.resource.height }}</span></div>
                  <div class="info-row"><span class="info-label">资源格式</span><span class="info-value">{{
                    detailStatic.resource.full_preview_url.split('.').pop() || ''
                      }}</span></div>
                  <div class="info-row"><span class="info-label">资源大小</span><span class="info-value">{{
                    detailStatic.resource.file_size_mb

                      }}MB</span></div>
                  <div class="info-row"><span class="info-label">上传时间</span><span class="info-value">{{ detailStatic.
                    resource.created_time

                      }}</span></div>
                </div>
              </div>
              <div class="sec" v-if="detailStatic.categories[0]">
                <div class="sec-title">分类 </div>
                <div class="sec-muted">{{ detailStatic.categories[0].name || '' }}</div>
              </div>
              <div class="sec">
                <div class="sec-title flex items-center justify-between"><span>标签</span></div>
                <div class="sec-muted" v-if="!detailStatic.tags.length">未关联标签</div>
                <div class="side-tags" v-else>
                  <span class="tag-chip" v-for="t in detailStatic.tags" :key="t">{{ t.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <MoveDialog v-model="moveVisible" :type="'resource'" :corp-code="props.corpCode"
      :current="{ folder_id: currentFolder.value?.id || '' }" :resource="selectedItem" :action="moveAction"
      :teams="[{ team_name: rootLabel, team_id: props.corpCode, }]" @confirm="onMoveConfirm" />
  </div>
</template>
<script setup lang="ts">
import { ElButton, ElIcon, ElEmpty, ElScrollbar, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElDialog, ElSkeleton, ElSkeletonItem } from 'element-plus'
import { Star, MoreFilled } from '@element-plus/icons-vue'
import { ref, onMounted, watch, computed } from 'vue'
import { getResourceList } from '@/api/affairs'
import { useSdkStore } from '@/stores/sdk'
import { multipleChoiceStore } from "@/stores/multipleChoice"
const sdkStore = useSdkStore()
const multipleChoice = multipleChoiceStore()
const desginsdk = sdkStore.getSdk()
//@ts-ignore
import MoveDialog from '@/views/shared/components/MoveDialog.vue'
import { folderOperate, resourceDetail, resourceFav } from '@/api/ResourceMasonry'
const selectedResources = computed(() => multipleChoice.getSelectedResources())
const selectedSet = computed(() => new Set(selectedResources.value))
const multipleChoiceShow = computed(() => multipleChoice.multipleChoice)
const isResourcesSelected = (id: any) => {
  return selectedSet.value.has(id)
}

const onSelect = (item: any) => {
  multipleChoice.setselectedResources(item.id)
}

const selectonClick = (item: any) => {
  if (multipleChoiceShow.value) {
    onSelect(item)
  }
}



const props = defineProps({
  id: { type: Number, default: 0 },
  corpCode: { type: String, default: '' },
  showUploadWhenEmpty: { type: Boolean, default: false },
  rootLabel: { type: String, default: '' }
})
const emit = defineEmits(['upload'])

const resourceList = ref<any[]>([])
const pageNum = ref(1)
const pageSize = ref(50)
const hasMore = ref(true)
const initialLoading = ref(false)
const loadingMore = ref(false)
const totalPage = ref(0)
const currentFolder = ref<{ id: string | number | undefined }>({ id: '' })
const file_type = ref<string | number | ''>('')
const category_id = ref<string | number | ''>('')
const file_suffix = ref<string | number | ''>('')
const tag_ids = ref<string | number | ''>('')
const searchText = ref<string | number | ''>('')

onMounted(() => {
  getList()
})

watch(() => props.id, (newVal, oldVal) => {
  if (newVal != oldVal) {
    pageNum.value = 1
    hasMore.value = true
    getList(false)
  }
})
const edittemplate = (_item: any) => {
  window.open(`/editor?id=${_item.id}&mode=user`)
}
const getList = (append = false) => {

  if (append && loadingMore.value) return
  if (append) loadingMore.value = true
  if (!append) initialLoading.value = true
  const params: any = {
    page: pageNum.value,
    size: pageSize.value,
    file_type: file_type.value,
    folder_id: currentFolder.value?.id || '',
    category_id: category_id.value || '',
    file_suffix: file_suffix.value || '',
    tag_ids: tag_ids.value || '',
    keyword: searchText.value || '',
    is_single: 1,
    owner_type: props.corpCode ? 'team' : 'user',
  }

  if (props.corpCode) params.corp_code = props.corpCode
  getResourceList(params).then(res => {
    multipleChoice.clearSelected()
    const items = res?.data?.data?.items || []
    totalPage.value = res?.data?.data?.total_pages || 0
    if (append) resourceList.value = (resourceList.value || []).concat(items)
    else resourceList.value = items
    hasMore.value = items.length === pageSize.value
  }).finally(() => {
    loadingMore.value = false
    if (!append) initialLoading.value = false
  })
}

const parentgetList = (f: any) => {
  if (f?.currentFolder) currentFolder.value = f.currentFolder
  if (f?.file_type === '' || f?.file_type) file_type.value = f.file_type
  if (f?.category_id === '' || f?.category_id) category_id.value = f.category_id
  if (f?.file_suffix === '' || f?.file_suffix) file_suffix.value = f.file_suffix
  if (f?.tag_ids === '' || f?.tag_ids) tag_ids.value = f.tag_ids
  if (f?.search === '' || f?.search) searchText.value = f.search

  pageNum.value = 1
  hasMore.value = true
  getList(false)
}
defineExpose({ getList, parentgetList })


const onFav = (_item: any) => {
  let params = {
    owner_type: props.corpCode ? 'team' : 'user',
    target_type: 5,
    target_id: _item.id,
    folder_id: '',
    corp_code: props.corpCode
  }
  resourceFav(params).then(res => {
    if (res?.data?.code === 0) {
      _item.is_favorite = !_item.is_favorite
      ElMessage.success('操作成功')
    }
  })
}
const moveVisible = ref(false)
const moveAction = ref<'move' | 'copy'>('move')
const selectedItem = ref<any>(null)
const detailVisible = ref(false)
const detailItem = ref<any>(null)
const detailStatic = ref()
const onItemCommand = (cmd: string, item: any) => {
  if (cmd === 'detail') { detailItem.value = item; onDetailConfirm(); return }
  if (cmd === 'download') { onDownload(item); return }
  if (cmd === 'move') { selectedItem.value = item; moveAction.value = 'move'; moveVisible.value = true; return }
  if (cmd === 'copy') { selectedItem.value = item; moveAction.value = 'copy'; moveVisible.value = true; return }
  if (cmd === 'edit') { edittemplate(item); return }
  if (cmd === 'delete') {
    deleteResource(item)
    return
  }
}
const copyResource = (item: any) => {

  selectedItem.value = item; moveAction.value = 'copy'; moveVisible.value = true; return
}
const moveResource = (item: any) => {
  selectedItem.value = item; moveAction.value = 'move'; moveVisible.value = true; return
}
const deleteResource = (item: any) => {
  console.log(item)
  ElMessageBox.confirm(`确认删除资源“${item.name || item.file_name || ''}”？删除后不可恢复`, '删除资源', {
    confirmButtonText: '删除',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    try {
      await folderOperate({ kind: 'resource', action: 'delete', resource_id: item.id, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode })
      resourceList.value = resourceList.value.filter(x => x.id !== item.id)
      ElMessage.success('资源已删除')
      detailVisible.value = false
    } catch { }
  }).catch(() => { })
}
const onDetailConfirm = () => {
  resourceDetail({ resource_id: detailItem.value.id, corp_code: props.corpCode, owner_type: props.corpCode ? 'team' : 'user' }).then(res => {
    const item = res?.data?.data || {}
    detailStatic.value = item
    detailVisible.value = true
  })
}

const onMoveConfirm = () => {
  pageNum.value = 1
  hasMore.value = true
  getList(false)
}
const onDownload = (item: any) => {
  console.log(item)
  const url = item?.full_preview_url
  if (url) window.open(url, '_blank')
}

const onScroll = (e: string) => {
  if (pageNum.value >= totalPage.value) return
  if (e == 'bottom') {
    pageNum.value += 1
    getList(true)
  }
}
const scrollbarRef = ref<any>(null)
const scrollWrapEl = computed(() => scrollbarRef.value?.wrapRef as HTMLElement | undefined)
const optimizeImageUrl = (url: any, w = 400, q = 80) => {
  const s = String(url || '')
  if (!s) return s
  const lower = s.toLowerCase()
  const isSvg = lower.endsWith('.svg') || lower.includes('.svg?') || lower.includes('format=svg')
  if (isSvg) return s
  const proc = `x-oss-process=image/resize,w_${w}/quality,q_${q}/format,webp`
  return s.includes('?') ? `${s}&${proc}` : `${s}?${proc}`
}
const getPreviewSrc = (item: any) => optimizeImageUrl(item?.full_preview_url, 400, 80)
const getDetailPreviewSrc = (item: any) => optimizeImageUrl(item?.full_preview_url, 1600, 85)
</script>
<style lang="scss" scoped>
.masonry {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 16px;
}

.masonry-item {
  content-visibility: auto;
  contain-intrinsic-size: 200px 200px;
}

.masonry-content {
  border-radius: 10px;
  overflow: hidden;
  background: #f5f7fa;
  aspect-ratio: 1 / 1;
  position: relative;
  transition: box-shadow .15s ease;
}

.masonry-item .masonry-content:hover {
  box-shadow: 0 6px 16px rgba(11, 16, 41, 0.12);
}

.media {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.favorite {
  color: #ff4d4f;
}

.caption {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 8px;
  height: 24px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 0 0 1px #e6e8eb;
  display: flex;
  align-items: center;
  padding: 0 8px;
  font-size: 12px;
  color: #38393b;
  opacity: 1;
  transition: opacity .15s ease;
}

.caption-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.masonry-content:hover .caption {
  opacity: 0;
}

.select-indicator {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 0 0 1px #e6e8eb;
  opacity: 0;
  transition: opacity .15s ease;
}

.multipleChoiceShow {
  .select-indicator {
    opacity: 1;
  }
}

.hover-actions {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 8px;
  opacity: 0;
  transform: translateY(-4px);
  transition: opacity .15s ease, transform .15s ease;
}

.action-btn {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 0 1px #e6e8eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0b1029;
}

.download-btn {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity .15s ease;
  z-index: 10;
}

.masonry-content:hover .hover-actions,
.masonry-content:hover .select-indicator,
.masonry-content:hover .download-btn {
  opacity: 1;
}

.detail {
  display: flex;
}

.preview-center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.big-preview {
  max-width: 80%;
  max-height: 80%;
  border-radius: 12px;
  border: 1px solid #eef1f5;
  background: #fff;
  object-fit: contain;
}

.detail-thumb {
  width: 180px;
  height: 180px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #eef1f5;
}

.detail-info {
  display: grid;
  gap: 8px;
  align-content: start;
}

.detail-info .row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.detail-info .label {
  width: 48px;
  font-size: 12px;
  color: #8a8f99;
}

.detail-info .value {
  font-size: 12px;
  color: #38393b;
}

.sec {
  margin-bottom: 16px;
}

.sec-title {
  font-size: 14px;
  color: #0b1029;
  font-weight: 600;
  margin-bottom: 10px;
}

.name-box {
  border: 1px solid #e6e8eb;
  border-radius: 10px;
  height: 36px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 12px;
  color: #38393b;
  background: #fff;
}

.info-card {
  background: #f5f7fa;
  border: 1px solid #eef1f5;
  border-radius: 10px;
  padding: 10px;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.info-label {
  font-size: 12px;
  color: #8a8f99;
}

.info-value {
  font-size: 12px;
  color: #38393b;
}

.badge-coop {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 12px;
  font-size: 12px;
  margin-left: 6px;
  background: #ffe7cc;
  color: #b86d00;
}

.sec-muted {
  font-size: 12px;
  color: #8a8f99;
}

.side-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-chip {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 8px;
  border: 1px solid #e6e8eb;
  border-radius: 8px;
  font-size: 12px;
  color: #38393b;
  background: #fff;
}

.selectborder {
  border: 2px solid #007bff;
  border-radius: 10px;
  box-sizing: border-box;
}
</style>
<style>
.resource .el-dialog__header {
  padding: 0 !important;
}
</style>
